export const ROOT_ROUTE = '/category-management';

export const CONFIG = [
	{
		path: `${ROOT_ROUTE}/insights`,
		name: 'insights',
		label: 'Insights',
	},
	{
		path: `${ROOT_ROUTE}/dashboard`,
		name: 'dashboard',
		label: 'Dashboard',
	},
	{
		path: `${ROOT_ROUTE}/vendor-segmentation`,
		name: 'vendorSegmentation',
		label: 'Vendor Segmentation',
	},
	{
		path: `${ROOT_ROUTE}/category-widgets`,
		name: 'categoryWidget',
		label: 'Category Widgets',
	},
];
